/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClaimPhoto,
  CreateClaimPhotoRequest,
  ErrorEnvelope,
  ListClaimPhotosResponse,
  Problem,
  UpdateClaimPhotoRequest,
} from '../models/index';
import {
    ClaimPhotoFromJSON,
    ClaimPhotoToJSON,
    CreateClaimPhotoRequestFromJSON,
    CreateClaimPhotoRequestToJSON,
    ErrorEnvelopeFromJSON,
    ErrorEnvelopeToJSON,
    ListClaimPhotosResponseFromJSON,
    ListClaimPhotosResponseToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    UpdateClaimPhotoRequestFromJSON,
    UpdateClaimPhotoRequestToJSON,
} from '../models/index';

export interface CreateClaimPhotoOperationRequest {
    claimId: number;
    createClaimPhotoRequest: CreateClaimPhotoRequest;
}

export interface DeleteClaimPhotoRequest {
    claimId: number;
    id: number;
}

export interface GetClaimPhotoContentRequest {
    claimId: number;
    id: number;
}

export interface GetClaimPhotoThumbnailRequest {
    claimId: number;
    id: number;
}

export interface GetClaimPhotosRequest {
    claimId: number;
}

export interface UpdateClaimPhotoOperationRequest {
    claimId: number;
    id: number;
    updateClaimPhotoRequest: UpdateClaimPhotoRequest;
}

/**
 * ClaimPhotosApi - interface
 * 
 * @export
 * @interface ClaimPhotosApiInterface
 */
export interface ClaimPhotosApiInterface {
    /**
     * Upload an image or short video to a claim\'s media library.
     * @summary Upload a photo to a claim
     * @param {number} claimId Claim ID
     * @param {CreateClaimPhotoRequest} createClaimPhotoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimPhotosApiInterface
     */
    createClaimPhotoRaw(requestParameters: CreateClaimPhotoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimPhoto>>;

    /**
     * Upload an image or short video to a claim\'s media library.
     * Upload a photo to a claim
     */
    createClaimPhoto(requestParameters: CreateClaimPhotoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimPhoto>;

    /**
     * Soft-delete a photo from a claim\'s media library.
     * @summary Delete a claim photo
     * @param {number} claimId Claim ID
     * @param {number} id Photo ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimPhotosApiInterface
     */
    deleteClaimPhotoRaw(requestParameters: DeleteClaimPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Soft-delete a photo from a claim\'s media library.
     * Delete a claim photo
     */
    deleteClaimPhoto(requestParameters: DeleteClaimPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Retrieve the raw image/video bytes for a claim photo.
     * @summary Download a claim photo\'s content
     * @param {number} claimId Claim ID
     * @param {number} id Photo ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimPhotosApiInterface
     */
    getClaimPhotoContentRaw(requestParameters: GetClaimPhotoContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Retrieve the raw image/video bytes for a claim photo.
     * Download a claim photo\'s content
     */
    getClaimPhotoContent(requestParameters: GetClaimPhotoContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * Retrieve a 256px WebP thumbnail for an image. Video thumbnails are not generated.
     * @summary Get a claim photo thumbnail
     * @param {number} claimId Claim ID
     * @param {number} id Photo ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimPhotosApiInterface
     */
    getClaimPhotoThumbnailRaw(requestParameters: GetClaimPhotoThumbnailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Retrieve a 256px WebP thumbnail for an image. Video thumbnails are not generated.
     * Get a claim photo thumbnail
     */
    getClaimPhotoThumbnail(requestParameters: GetClaimPhotoThumbnailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * Retrieve the media library (photos and short video clips) for a claim.
     * @summary List all photos for a claim
     * @param {number} claimId Claim ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimPhotosApiInterface
     */
    getClaimPhotosRaw(requestParameters: GetClaimPhotosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListClaimPhotosResponse>>;

    /**
     * Retrieve the media library (photos and short video clips) for a claim.
     * List all photos for a claim
     */
    getClaimPhotos(requestParameters: GetClaimPhotosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListClaimPhotosResponse>;

    /**
     * Update the filename and/or caption of a claim photo.
     * @summary Update a claim photo\'s metadata
     * @param {number} claimId Claim ID
     * @param {number} id Photo ID
     * @param {UpdateClaimPhotoRequest} updateClaimPhotoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimPhotosApiInterface
     */
    updateClaimPhotoRaw(requestParameters: UpdateClaimPhotoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimPhoto>>;

    /**
     * Update the filename and/or caption of a claim photo.
     * Update a claim photo\'s metadata
     */
    updateClaimPhoto(requestParameters: UpdateClaimPhotoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimPhoto>;

}

/**
 * 
 */
export class ClaimPhotosApi extends runtime.BaseAPI implements ClaimPhotosApiInterface {

    /**
     * Upload an image or short video to a claim\'s media library.
     * Upload a photo to a claim
     */
    async createClaimPhotoRaw(requestParameters: CreateClaimPhotoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimPhoto>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling createClaimPhoto().'
            );
        }

        if (requestParameters['createClaimPhotoRequest'] == null) {
            throw new runtime.RequiredError(
                'createClaimPhotoRequest',
                'Required parameter "createClaimPhotoRequest" was null or undefined when calling createClaimPhoto().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/photos`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClaimPhotoRequestToJSON(requestParameters['createClaimPhotoRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimPhotoFromJSON(jsonValue));
    }

    /**
     * Upload an image or short video to a claim\'s media library.
     * Upload a photo to a claim
     */
    async createClaimPhoto(requestParameters: CreateClaimPhotoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimPhoto> {
        const response = await this.createClaimPhotoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Soft-delete a photo from a claim\'s media library.
     * Delete a claim photo
     */
    async deleteClaimPhotoRaw(requestParameters: DeleteClaimPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling deleteClaimPhoto().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteClaimPhoto().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/photos/{id}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Soft-delete a photo from a claim\'s media library.
     * Delete a claim photo
     */
    async deleteClaimPhoto(requestParameters: DeleteClaimPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteClaimPhotoRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve the raw image/video bytes for a claim photo.
     * Download a claim photo\'s content
     */
    async getClaimPhotoContentRaw(requestParameters: GetClaimPhotoContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimPhotoContent().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getClaimPhotoContent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/photos/{id}/content`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Retrieve the raw image/video bytes for a claim photo.
     * Download a claim photo\'s content
     */
    async getClaimPhotoContent(requestParameters: GetClaimPhotoContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getClaimPhotoContentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a 256px WebP thumbnail for an image. Video thumbnails are not generated.
     * Get a claim photo thumbnail
     */
    async getClaimPhotoThumbnailRaw(requestParameters: GetClaimPhotoThumbnailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimPhotoThumbnail().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getClaimPhotoThumbnail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/photos/{id}/thumbnail`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Retrieve a 256px WebP thumbnail for an image. Video thumbnails are not generated.
     * Get a claim photo thumbnail
     */
    async getClaimPhotoThumbnail(requestParameters: GetClaimPhotoThumbnailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getClaimPhotoThumbnailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the media library (photos and short video clips) for a claim.
     * List all photos for a claim
     */
    async getClaimPhotosRaw(requestParameters: GetClaimPhotosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListClaimPhotosResponse>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimPhotos().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/photos`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListClaimPhotosResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve the media library (photos and short video clips) for a claim.
     * List all photos for a claim
     */
    async getClaimPhotos(requestParameters: GetClaimPhotosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListClaimPhotosResponse> {
        const response = await this.getClaimPhotosRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the filename and/or caption of a claim photo.
     * Update a claim photo\'s metadata
     */
    async updateClaimPhotoRaw(requestParameters: UpdateClaimPhotoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimPhoto>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling updateClaimPhoto().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateClaimPhoto().'
            );
        }

        if (requestParameters['updateClaimPhotoRequest'] == null) {
            throw new runtime.RequiredError(
                'updateClaimPhotoRequest',
                'Required parameter "updateClaimPhotoRequest" was null or undefined when calling updateClaimPhoto().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/photos/{id}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClaimPhotoRequestToJSON(requestParameters['updateClaimPhotoRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimPhotoFromJSON(jsonValue));
    }

    /**
     * Update the filename and/or caption of a claim photo.
     * Update a claim photo\'s metadata
     */
    async updateClaimPhoto(requestParameters: UpdateClaimPhotoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimPhoto> {
        const response = await this.updateClaimPhotoRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
